// src/components/sections/Footer.jsx
// Redesigned footer - centered, clean

import React from 'react';

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-gt-silver-200 bg-white/70 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        {/* Logo centered */}
        <div className="flex justify-center mb-4">
          <img src="/logo2026.png" alt="GPS Tech" className="h-16 object-contain" />
        </div>

        {/* Description */}
        <p className="text-sm text-gt-dark-400 leading-relaxed text-center max-w-md mx-auto mb-10">
          Telemetry software for businesses worldwide. GPS tracking,
          fleet management, and SARS-compliant logbooks. Founded in South Africa.
        </p>

        {/* Nav + Products row */}
        <div className="flex flex-col items-center gap-8 mb-10">
          {/* Section links */}
          <div className="flex flex-wrap justify-center gap-6">
            {['products', 'about', 'faq', 'contact'].map((id) => (
              <button
                key={id}
                onClick={() => scrollTo(id)}
                className="text-sm text-gt-dark-400 hover:text-teal-600 transition-colors capitalize"
              >
                {id}
              </button>
            ))}
          </div>

          {/* Product links */}
          <div className="flex flex-wrap justify-center gap-6">
            <a href="https://tripdata.co.za" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors">
              TripData
            </a>
            <a href="https://geodrive.co.za" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors">
              GeoDrive
            </a>
            <a href="https://geofleet.co.za" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors">
              GeoFleet
            </a>
          </div>

          {/* Contact */}
          <a
            href="mailto:hello@gpstech.co.za"
            className="text-sm text-gt-dark-400 hover:text-teal-600 transition-colors"
          >
            hello@gpstech.co.za
          </a>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gt-silver-200 flex flex-col items-center gap-3">
          <p className="text-xs text-gt-silver-400">
            &copy; {new Date().getFullYear()} GPS Tech (Pty) Ltd. All rights reserved.
          </p>
          <p className="text-xs text-gt-silver-400 inline-flex items-center gap-1">
            Made with{' '}
            <svg className="w-3 h-3 text-red-500 fill-red-500" viewBox="0 0 24 24">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            {' '}by{' '}
            <a
              href="https://codebooth.co.za"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-600 hover:underline"
            >
              CodeBooth
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;